import { useEffect, useRef } from 'react'
import { navigateToUrl } from 'shared/helpers'

function handleNavigate(e: any) {
  e.preventDefault()
  if (this.href) {
    navigateToUrl(this.href)
  }
}

export const useCustomLinkHtml = (html?: string) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref.current && html) {
      const elements = ref.current.getElementsByTagName('a')
      for (let i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', handleNavigate, false)
      }

      const iframes = ref.current.getElementsByTagName('iframe')

      for (let i = 0; i < iframes.length; i++) {
        const width = iframes[i].getAttribute('width')
        const height = iframes[i].getAttribute('height')
        if (width && height && !(width.includes('%') || height.includes('%'))) {
          iframes[i].setAttribute('style', `height: unset; aspect-ratio: ${parseFloat(width) / parseFloat(height)}`)
        }
      }

      return () => {
        for (let i = 0; i < elements.length; i++) {
          elements[i].removeEventListener('click', handleNavigate, false)
        }
      }
    }
  }, [html])

  return ref
}
